import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import { RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import AdminActiveAadeCases from "src/aadeCase/features/AdminActiveAadeCases";
import ManageAadeCaseApplication from "src/aadeCase/features/ManageAadeCaseApplication";
import AdminPastAadeCases from "src/aadeCase/features/AdminPastAadeCases";
import AdminUnregisteredAadeCases from "src/aadeCase/features/AdminUnregisteredAadeCases";

const SendNotificationHistory = lazyWithReload(
  () =>
    import("../admin/features/SendNotificationHistory/SendNotificationHistory"),
);
const SendNotificationToCompany = lazyWithReload(
  () =>
    import(
      "../admin/features/SendNotificationToCompany/SendNotificationToCompany"
    ),
);
const SendNotificationToAllUsers = lazyWithReload(
  () =>
    import(
      "../admin/features/SendNotificationToAllUsers/SendNotificationToAllUsers"
    ),
);

const ActiveBusiness = lazyWithReload(
  () => import("src/admin/features/ActiveBusiness/ActiveBusiness"),
);
const AlterUser = lazyWithReload(
  () => import("src/admin/features/AlterUser/AlterUser"),
);
const Applications = lazyWithReload(
  () => import("src/admin/features/Applications/Applications"),
);
const AppTypes = lazyWithReload(
  () => import("src/admin/features/AppTypes/AppTypes"),
);
const Certificates = lazyWithReload(
  () => import("src/admin/features/Certificates/Certificates"),
);
const CertPayments = lazyWithReload(
  () => import("src/admin/features/CertPayments/CertPayments"),
);
const CertTypes = lazyWithReload(
  () => import("src/admin/features/CertTypes/CertTypes"),
);
const CompanyRefundSubscription = lazyWithReload(
  () =>
    import(
      "src/admin/features/CompanyRefundSubscription/CompanyRefundSubscription"
    ),
);
const DiasFileDetails = lazyWithReload(
  () => import("src/admin/features/DiasFileDetails/DiasFileDetails"),
);
const DiasFiles = lazyWithReload(
  () => import("src/admin/features/DiasFiles/DiasFiles"),
);
const DiasFix = lazyWithReload(
  () => import("src/admin/features/DiasFix/DiasFix"),
);
const DiasOnline = lazyWithReload(
  () => import("src/admin/features/DiasOnline/DiasOnline"),
);
const FixMissingInvoices = lazyWithReload(
  () => import("src/admin/features/fixMissingInvoices/FixMissingInvoices"),
);
const FixWrongRi3DiasPayment = lazyWithReload(
  () =>
    import("src/admin/features/FixWrongRi3DiasPayment/FixWrongRi3DiasPayment"),
);
const ImpersonationPage = lazyWithReload(
  () => import("src/admin/features/ImpersonationPage/ImpersonationPage"),
);
const ImpersonationPageBusiness = lazyWithReload(
  () =>
    import(
      "src/admin/features/ImpersonationPageBusiness/ImpersonationPageBusiness"
    ),
);
const ListJobs = lazyWithReload(
  () => import("src/admin/features/ListJobs/ListJobs"),
);
const AadeManualSync = lazyWithReload(
  () => import("src/admin/features/AadeManualSync/AadeManualSync"),
);
const MaintenanceForm = lazyWithReload(
  () => import("src/admin/features/maintenanceForm/MaintenanceForm"),
);
const NameTitleClaimPurchase = lazyWithReload(
  () =>
    import("src/admin/features/NameTitleClaimPurchase/NameTitleClaimPurchase"),
);
const NameTitlePurchase = lazyWithReload(
  () => import("src/admin/features/NameTitlePurchase/NameTitlePurchase"),
);
const NewChamberFeatureForm = lazyWithReload(
  () =>
    import("src/admin/features/newChamberFeatureForm/NewChamberFeatureForm"),
);
const OrgAdmin = lazyWithReload(
  () => import("src/admin/features/orgAdmin/OrgAdmin"),
);
const PaidSubscriptions = lazyWithReload(
  () => import("src/admin/features/paidSubscriptions/PaidSubscriptions"),
);
const PaymentDetails = lazyWithReload(
  () => import("src/admin/features/PaymentDetails/PaymentDetails"),
);
const PaymentSums = lazyWithReload(
  () => import("src/admin/features/PaymentSums/PaymentsSums"),
);
const Quick = lazyWithReload(() => import("src/admin/features/Quick/Quick"));
const QuickConfiguration = lazyWithReload(
  () => import("src/admin/features/QuickConfiguration/QuickConfiguration"),
);
const QuickSql = lazyWithReload(
  () => import("src/admin/features/QuickSql/QuickSql"),
);
const ShowSubscr = lazyWithReload(
  () => import("src/admin/features/ShowSubscr/ShowSubscr"),
);
const Tools = lazyWithReload(() => import("src/admin/features/Tools/Tools"));
const UpdatePaymentsForRefund = lazyWithReload(
  () =>
    import(
      "src/admin/features/UpdatePaymentsForRefund/UpdatePaymentsForRefund"
    ),
);
const ViewPaymentsForRefund = lazyWithReload(
  () =>
    import("src/admin/features/ViewPaymentsForRefund/ViewPaymentsForRefund"),
);
const InspectPayment = lazyWithReload(
  () => import("src/admin/features/ΙnspectPayment/InspectPayment"),
);
const ChamberDetails = lazyWithReload(
  () => import("src/cashier/features/chamberDetails/ChamberDetails"),
);
const ActiveBusinessCount = lazyWithReload(
  () => import("src/chamber/features/activeBusinessCount/ActiveBusinessCount"),
);
const CashierReport = lazyWithReload(
  () => import("src/chamber/features/cashierReport/CashierReport"),
);
const CashierStats = lazyWithReload(
  () => import("src/chamber/features/cashierStats/CashierStats"),
);
const CompanyReducedSubscription = lazyWithReload(
  () =>
    import(
      "src/chamber/features/companyReducedSubscription/CompanyReducedSubscription"
    ),
);
const DeleteKak = lazyWithReload(
  () => import("src/chamber/features/deleteKak/DeleteKak"),
);
const InactiveApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/InactiveUserAssignments/ui/InactiveApplications"
    ),
);
const InactiveCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/InactiveUserAssignments/ui/InactiveCertificateApplications"
    ),
);
const FinancialReport = lazyWithReload(
  () => import("src/chamber/features/financialReport/FinancialReport"),
);
const KedeSubscriptions = lazyWithReload(
  () => import("src/chamber/features/kedeSubscriptions/KedeSubscriptions"),
);
const ManageSubscription = lazyWithReload(
  () => import("src/chamber/features/manageSubscription/ManageSubscription"),
);
const UnpaidSubscriptions = lazyWithReload(
  () => import("src/chamber/features/unpaidSubscriptions/UnpaidSubscriptions"),
);
const ManageApplication = lazyWithReload(
  () => import("src/admin/features/ManageApplication/ManageApplication"),
);
const Payments = lazyWithReload(
  () => import("src/admin/features/Payments/Payments"),
);
const ManageCertificateApplication = lazyWithReload(
  () =>
    import(
      "src/admin/features/ManageCertificateApplication/ManageCertificateApplication"
    ),
);
const WrongSubscriptions = lazyWithReload(
  () => import("src/admin/features/WrongSubscriptions/WrongSubscriptions"),
);
const FixApplicationForm = lazyWithReload(
  () => import("src/admin/features/FixApplicationForm/FixApplicationForm"),
);
const MoveAllAppToNewChamber = lazyWithReload(
  () =>
    import("src/admin/features/MoveAllAppToNewChamber/MoveAllAppToNewChamber"),
);
const KakIpReport = lazyWithReload(
  () => import("src/admin/features/KakIpReport/KakIpReport"),
);
const PaymentsFix = lazyWithReload(
  () => import("src/admin/features/PaymentsFix/PaymentsFix"),
);
const PaymentIntegrity = lazyWithReload(
  () => import("src/admin/features/PaymentIntegrity/PaymentIntegrity"),
);
const SubscriptionRelief = lazyWithReload(
  () => import("src/admin/features/SubscriptionRelief/SubscriptionRelief"),
);
const UpdateSepaPayments = lazyWithReload(
  () => import("src/admin/features/UpdateSepaPayment/UpdateSepaPayments"),
);
const UpdateUnpaidSubscrFlags = lazyWithReload(
  () =>
    import(
      "src/admin/features/UpdateUnpaidSubscrFlags/UpdateUnpaidSubscrFlags"
    ),
);
const WrongChamberForApplication = lazyWithReload(
  () =>
    import(
      "src/admin/features/WrongChamberForApplication/WrongChamberForApplication"
    ),
);

const ImpersonationPageNonGemi = lazyWithReload(
  () =>
    import(
      "src/admin/features/ImpersonationPageNonGemi/ImpersonationPageNonGemi"
    ),
);
const BulkViolationCases = lazyWithReload(
  () => import(
    "src/admin/features/BulkViolationCases/BulkViolationCases"
  ),
);

export const adminPaths: RouteObject = {
  path: "/admin",
  children: [
    {
      path: "applications",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <Applications />
        </RouteProtector>
      ),
    },
    {
      path: "certificates",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <Certificates />
        </RouteProtector>
      ),
    },
    {
      path: "cashierStats",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <CashierStats />
        </RouteProtector>
      ),
    },
    {
      path: "nameTitlePurchase",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <NameTitlePurchase />
        </RouteProtector>
      ),
    },
    {
      path: "nameTitleClaimPurchase",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <NameTitleClaimPurchase />
        </RouteProtector>
      ),
    },
    {
      path: "financialReport",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <FinancialReport />
        </RouteProtector>
      ),
    },
    {
      path: "cashierReport",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <CashierReport />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication/:appId",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <ManageApplication />
        </RouteProtector>
      ),
    },
    {
      path: "unpaidSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <UnpaidSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "kedeSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <KedeSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "manageCertificateApplication/:certId",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <ManageCertificateApplication />
        </RouteProtector>
      ),
    },
    {
      path: "paidSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <PaidSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "payments",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <Payments />
        </RouteProtector>
      ),
    },
    {
      path: "certPayments",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <CertPayments />
        </RouteProtector>
      ),
    },
    {
      path: "paymentSums",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <PaymentSums />
        </RouteProtector>
      ),
    },
    {
      path: "updatePaymentsForRefund",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <UpdatePaymentsForRefund />
        </RouteProtector>
      ),
    },
    {
      path: "viewPaymentsForRefund",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ViewPaymentsForRefund />
        </RouteProtector>
      ),
    },
    {
      path: "diasFiles",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <DiasFiles />
        </RouteProtector>
      ),
    },
    {
      path: "quickSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <Quick />
        </RouteProtector>
      ),
    },
    {
      path: "diasFileDetails/:fileId",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <DiasFileDetails />
        </RouteProtector>
      ),
    },
    {
      path: "quickCertificates",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <Quick />
        </RouteProtector>
      ),
    },
    {
      path: "diasOnline",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <DiasOnline />
        </RouteProtector>
      ),
    },
    {
      path: "quickUserRegistrationsNonGemi",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <Quick />
        </RouteProtector>
      ),
    },
    {
      path: "diasFix",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <DiasFix />
        </RouteProtector>
      ),
    },
    {
      path: "quickUserRegistrationsGemi",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <Quick />
        </RouteProtector>
      ),
    },
    {
      path: "inspectPayment",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <InspectPayment />
        </RouteProtector>
      ),
    },
    {
      path: "listJobs",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ListJobs />
        </RouteProtector>
      ),
    },
    {
      path: "aadeManualSync",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <AadeManualSync />
        </RouteProtector>
      ),
    },
    {
      path: "fixWrongRi3DiasPayment",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <FixWrongRi3DiasPayment />
        </RouteProtector>
      ),
    },
    {
      path: "paymentDetails",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <PaymentDetails />
        </RouteProtector>
      ),
    },
    {
      path: "activeBusiness",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ActiveBusiness />
        </RouteProtector>
      ),
    },
    {
      path: "activeBusinessCount",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ActiveBusinessCount />
        </RouteProtector>
      ),
    },
    {
      path: "orgAdmin",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <OrgAdmin />
        </RouteProtector>
      ),
    },
    {
      path: "appTypes",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <AppTypes />
        </RouteProtector>
      ),
    },
    {
      path: "certTypes",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <CertTypes />
        </RouteProtector>
      ),
    },
    {
      path: "fixMissingInvoices",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <FixMissingInvoices />
        </RouteProtector>
      ),
    },
    {
      path: "chamberDetails",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ChamberDetails />
        </RouteProtector>
      ),
    },
    {
      path: "wrongSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <WrongSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "showSubscr",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ShowSubscr />
        </RouteProtector>
      ),
    },
    {
      path: "companyRefundSubscription",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <CompanyRefundSubscription />
        </RouteProtector>
      ),
    },
    {
      path: "updateUnpaidSubscrFlags",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <UpdateUnpaidSubscrFlags />
        </RouteProtector>
      ),
    },
    {
      path: "wrongChamberForApplication",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <WrongChamberForApplication />
        </RouteProtector>
      ),
    },
    {
      path: "alterUser",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <AlterUser />
        </RouteProtector>
      ),
    },
    {
      path: "impersonationPage",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ImpersonationPage />
        </RouteProtector>
      ),
    },
    {
      path: "impersonationPageBusiness",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ImpersonationPageBusiness />
        </RouteProtector>
      ),
    },
    {
      path: "moveAllAppToNewChamber",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <MoveAllAppToNewChamber />
        </RouteProtector>
      ),
    },
    {
      path: "deleteKak",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <DeleteKak />
        </RouteProtector>
      ),
    },
    {
      path: "companyReducedSubscription",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <CompanyReducedSubscription />
        </RouteProtector>
      ),
    },
    {
      path: "inactiveApplications",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <InactiveApplications />
        </RouteProtector>
      ),
    },
    {
      path: "inactiveCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin", "isGGEAdmin"]}>
          <InactiveCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "subscriptionRelief",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <SubscriptionRelief />
        </RouteProtector>
      ),
    },
    {
      path: "quickSql",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <QuickSql />
        </RouteProtector>
      ),
    },
    {
      path: "maintenanceForm",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <MaintenanceForm />
        </RouteProtector>
      ),
    },
    {
      path: "fixApplicationForm",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <FixApplicationForm />
        </RouteProtector>
      ),
    },
    {
      path: "updateSepaPayments",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <UpdateSepaPayments />
        </RouteProtector>
      ),
    },
    {
      path: "quickConfiguration",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <QuickConfiguration />
        </RouteProtector>
      ),
    },
    {
      path: "tools",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <Tools />
        </RouteProtector>
      ),
    },
    {
      path: "kakIpReport",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <KakIpReport />
        </RouteProtector>
      ),
    },
    {
      path: "paymentsFix",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <PaymentsFix />
        </RouteProtector>
      ),
    },
    {
      path: "paymentIntegrity",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <PaymentIntegrity />
        </RouteProtector>
      ),
    },
    {
      path: "manageSubscription/:subId",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ManageSubscription />
        </RouteProtector>
      ),
    },
    {
      path: "newChamberFeatureForm",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <NewChamberFeatureForm />
        </RouteProtector>
      ),
    },
    {
      path: "sendNotificationHistory",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <SendNotificationHistory />
        </RouteProtector>
      ),
    },
    {
      path: "sendNotificationToCompany",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <SendNotificationToCompany />
        </RouteProtector>
      ),
    },
    {
      path: "sendNotificationToAllUsers",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <SendNotificationToAllUsers />
        </RouteProtector>
      ),
    },
    {
      path: "impersonationPageNonGemi",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <ImpersonationPageNonGemi />
        </RouteProtector>
      ),
    },
    {
      path: "bulkViolationCases",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <BulkViolationCases />
        </RouteProtector>
      ),
    },
    ...(import.meta.env.VITE_ClEANSING_ACTIVATED === "true"
      ? [
          {
            path: "activeAadeCases",
            element: (
              <RouteProtector allowedUsers={["isSystemAdmin"]}>
                <AdminActiveAadeCases />
              </RouteProtector>
            ),
          },
          {
            path: "pastAadeCases",
            element: (
              <RouteProtector allowedUsers={["isSystemAdmin"]}>
                <AdminPastAadeCases />
              </RouteProtector>
            ),
          },
          {
            path: "unRegisteredAadeCases",
            element: (
              <RouteProtector allowedUsers={["isSystemAdmin"]}>
                <AdminUnregisteredAadeCases />
              </RouteProtector>
            ),
          },
          {
            path: "manageAadeCaseApplication/:caseId",
            element: (
              <RouteProtector allowedUsers={["isSystemAdmin"]}>
                <ManageAadeCaseApplication />
              </RouteProtector>
            ),
          },
        ]
      : []),
  ],
};
